/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Info_Dialog_Print_BtnInputs */

const vi_print_info_dialog_print_btn = /** @type {(inputs: Print_Info_Dialog_Print_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In phiếu`)
};

/**

* @param {Print_Info_Dialog_Print_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_info_dialog_print_btn = /** @type {((inputs?: Print_Info_Dialog_Print_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Info_Dialog_Print_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_info_dialog_print_btn(inputs)
});